import commonApi from './api/commonApi';

// const oDc: any = {};
const oDataCenter: any = {
  ...commonApi
};
// oDc.install = function(Vue: any, options?:any) {
//   Vue.prototype.$dataCenter = oDataCenter
// }

export default oDataCenter